import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createTRPCClient } from '@trpc/client';
import type { AppRouter } from '@nemo/api';
import { App } from './App.js';
import { ToastProvider } from './ui/Toast.js';
import { TRPCProvider } from './trpc.js';
import { trpcLinks } from './trpcLinks.js';
import './index.css';

const queryClient = new QueryClient();
const trpcClient = createTRPCClient<AppRouter>({ links: trpcLinks() });

const container = document.getElementById('root');
if (container === null) throw new Error('missing #root');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
        <ToastProvider>
          <App />
        </ToastProvider>
      </TRPCProvider>
    </QueryClientProvider>
  </StrictMode>,
);
